(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7065],{

/***/ 18763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resigilate/[[...filters]]",
      function () {
        return __webpack_require__(94007);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26209);
/* harmony import */ var _containers_ErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75720);
/* harmony import */ var _containers_Catalog_ResealedList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46333);
/* harmony import */ var _components_withRouterPageLayout_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61167);
/* harmony import */ var _components_PromoToasts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30866);
/* harmony import */ var _lib_filterUtil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82594);
/* harmony import */ var _store_resealed_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74577);









function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// TODO: MEGA FUCKING WARNING!!
// MAKE SURE TO KEEP THINGS IN SYNC AT THE MOMENT
// resigilate/[[...filters]].js
// resigilate/[urlKey]/cpl/[[...filters]].js
var List = function(param) {
    var currentCategory = param.currentCategory;
    if (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.category) {
        var ref;
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Catalog_ResealedList__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_PromoToasts__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    type: "category",
                    params: {
                        categoryId: currentCategory === null || currentCategory === void 0 ? void 0 : (ref = currentCategory.category) === null || ref === void 0 ? void 0 : ref.id
                    }
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_ErrorPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        layout: "404"
    }));
};
List.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var reduxStore, query, res, queryFilters, filterPrefixIndex, extractedFiltersParams, categoryProducts;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = param.reduxStore, query = param.query, res = param.res;
                    queryFilters = query.filters || [];
                    filterPrefixIndex = queryFilters.findIndex(function(queryFilter) {
                        return queryFilter === "filtru";
                    });
                    if (filterPrefixIndex === 0) {
                        queryFilters.shift();
                    }
                    extractedFiltersParams = (0,_lib_filterUtil__WEBPACK_IMPORTED_MODULE_7__/* .extractFiltersParams */ .Nl)(queryFilters);
                    // Set the default number of items to bring
                    extractedFiltersParams.apiQueryParams = "".concat(extractedFiltersParams.apiQueryParams).concat(extractedFiltersParams.apiQueryParams === "" ? "?" : "&", "size=48");
                    _ctx.next = 8;
                    return reduxStore.dispatch((0,_store_resealed_actions__WEBPACK_IMPORTED_MODULE_8__/* .getCategoryResealedTree */ .L)());
                case 8:
                    _ctx.next = 10;
                    return reduxStore.dispatch((0,_store_resealed_actions__WEBPACK_IMPORTED_MODULE_8__/* .getCategoryResealed */ .R)(query, extractedFiltersParams));
                case 10:
                    categoryProducts = _ctx.sent;
                    if (res && !categoryProducts) {
                        res.statusCode = 404;
                    }
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
})();
List.pageLayout = "default";
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_withRouterPageLayout_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(function(state) {
    return {
        currentCategory: state.resealed.currentCategory
    };
})(List)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1423,5866,1961,1458,4997,9522,9774,2888,179], function() { return __webpack_exec__(18763); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);